import { EHeadingStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import { FormattedMessage } from 'react-intl';

import { formatCurrency } from '@/utility/currency';

interface IEscapeTileDescriptionProps {
  location: string;
  name: string;
  lowestPrice: number;
  presentmentCurrency: string;
}

export const EscapeTileDescription = ({
  location,
  name,
  lowestPrice,
  presentmentCurrency,
}: IEscapeTileDescriptionProps) => {
  return (
    <>
      <div className="flex flex-col gap-2">
        <Heading variant={EHeadingStyleVariant.H3} className="text-750">
          {location}
        </Heading>
        <Text className="font-medium text-300">{name}</Text>
      </div>
      <Text className="text-300">
        <FormattedMessage
          defaultMessage="RV + Delivery + Resort starting at <PriceSpan>{formattedPrice}/night</PriceSpan>"
          id="UrDcVM"
          values={{
            formattedPrice: formatCurrency({
              priceInCents: lowestPrice,
              currency: presentmentCurrency,
              ceil: true,
              digits: 0,
              maxDigits: 0,
            }),
            PriceSpan: text => <span className="font-medium text-600">{text}</span>,
          }}
        />
      </Text>
    </>
  );
};
